import { template as template_8f92342581754ec09a8245783e701f79 } from "@ember/template-compiler";
import { service } from '@ember/service';
import { shouldShowBanner } from '../utils/datagrail';
// eslint-disable-next-line no-restricted-imports -- this interval is the budget for an external script to appear, so it must elapse
import { task, timeout } from 'ember-concurrency';
import Component from '@glimmer/component';
export default class DgConsentBanner extends Component {
    @service
    cookies;
    @service
    fastboot;
    constructor(){
        super(...arguments);
        this.pollForConsentBannerTask.perform();
    }
    @task(function*() {
        let url;
        if (!this.fastboot?.isFastBoot) {
            url = `${window.location.pathname}${window.location.search}`;
        }
        let shouldShow = shouldShowBanner(this.fastboot?.isFastBoot, url, this.cookies);
        if (!shouldShow) {
            return;
        }
        const pollIntervalMs = 200;
        const maxPollMs = 10_000;
        const maxAttempts = Math.ceil(maxPollMs / pollIntervalMs);
        for(let attempts = 0; attempts < maxAttempts; attempts++){
            if (typeof window.DG_BANNER_API?.showConsentBanner === 'function') {
                window.DG_BANNER_API.showConsentBanner();
                return;
            }
            yield timeout(pollIntervalMs);
        }
    }).drop()
    pollForConsentBannerTask;
    static{
        template_8f92342581754ec09a8245783e701f79(`
    {{! intentionally renders nothing; polls for DG_BANNER_API and shows the consent banner }}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
